import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { later } from "@ember/runloop"
import styles from "./show-link-body.module.css"

@tagName("")
export default class CannotShareBodyComponent extends Component {
  readonly styles = styles

  // args
  goBack!: Function
  closeMenu!: Function

  // state
  linkButtonText = "Copy Link"

  // actions
  @action
  copyLink() {
    this.set("linkButtonText", "Copied!")
    later(() => {
      this.closeMenu()
    }, 1000)
  }
}
